type UnauthorizedHandler = () => Promise<void> | void;

let onUnauthorizedCallback: null | UnauthorizedHandler = null;
let refreshInFlight: Promise<void> | null = null;

export const setOnUnauthorized = (cb: UnauthorizedHandler) => {
  onUnauthorizedCallback = cb;
};

/**
 * Single-flight refresh: the first 401 starts the refresh, every other 401
 * that arrives while it is running awaits the same promise. The slot is
 * cleared once it settles so a later 401 can start a genuinely new attempt.
 * Rejects when the refresh failed (the SDK is already redirecting to logout).
 */
export const triggerOnUnauthorized = (): Promise<void> => {
  if (!onUnauthorizedCallback) return Promise.resolve();

  if (!refreshInFlight) {
    refreshInFlight = Promise.resolve(onUnauthorizedCallback()).finally(() => {
      refreshInFlight = null;
    });
  }

  return refreshInFlight;
};
